"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFriendlyDate = void 0;
const dayjs = require("dayjs");
const toFriendlyDate = (date) => {
    return dayjs(date).format("ddd, DD MMM YYYY");
};
exports.toFriendlyDate = toFriendlyDate;
